import { GetterTree, Module, MutationTree } from 'vuex'
import { MultiViewState, State } from '../types'

export enum MultiViewMutations {
    SET_SELECTED_MULTIDESK_TABLES = 'SET_SELECTED_MULTIDESK_TABLES'
}

const state: MultiViewState = {
    selectedTables: new Array<number>()
}

const mutations: MutationTree<MultiViewState> = {
    [MultiViewMutations.SET_SELECTED_MULTIDESK_TABLES](
        state,
        selectedTables: Array<number>
    ) {
        state.selectedTables = selectedTables
    }
}

const getters: GetterTree<MultiViewState, State> = {
    selectedTables(state): Array<number> {
        return state.selectedTables
    }
}

export const multiview: Module<MultiViewState, State> = {
    state,
    mutations,
    getters
}
